import { useEffect, useState } from 'react';

export const getName = () => {
  const abortController = new AbortController();
  const rta = fetch('/idp/name', { signal: abortController.signal })
    .then((r) => r.json())
    .then((r) => r.name)
    .catch(() => '');

  return [rta, abortController];
};

export const getIdp = (appId) => {
  const abortController = new AbortController();
  const from = window.location.pathname;
  const rta = fetch(`/idp/name?appId=${appId}&from=${from}`, { signal: abortController.signal })
    .then((r) => r.json())
    .catch(() => undefined);

  return [rta, abortController];
};

export const useIdp = () => {
  const [idp, setIdp] = useState();
  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const appId = search.get('client_id');
    const [rta, abortController] = getIdp(appId);
    rta.then((n) => { if (n) setIdp(n); });
    return () => {
      abortController.abort();
    };
  }, []);

  return idp;
};

export const getInfo = (page) => {
  const abortController = new AbortController();
  const search = new URLSearchParams(window.location.search);
  if (page) {
    search.set('from', page);
  }
  const rta = fetch(`/auth/get?${search.toString()}`, { method: 'POST', signal: abortController.signal })
    .then((r) => r.json())
    .catch(() => undefined);
  return [rta, abortController];
};

export const confirmUser = () => {
  const abortController = new AbortController();
  const search = new URLSearchParams(window.location.search);
  const rta = fetch(`/auth/confirmUser?${search.toString()}`, { method: 'POST', redirect: 'error', signal: abortController.signal })
    .then((r) => r.json())
    .catch(() => undefined);

  return [rta, abortController];
};
